import _ from 'underscore';

export const FluctuationType = {
  Default: 0,
  Impression: 1,
  Click: 2,
  Spend: 3,
  Conversion: 4,
  Max: 500,
};

export const FluctuationEnumToStringMap = (() => {
  const keyList = _.keys(FluctuationType);
  return _.object(keyList, keyList);
})();

export const ColumnNameToFluctuationTypeEnum = {
  Clicks: FluctuationEnumToStringMap.Click,
  Impressions: FluctuationEnumToStringMap.Impression,
  Spend: FluctuationEnumToStringMap.Spend,
  Conversions: FluctuationEnumToStringMap.Conversion,
};
